import ConnectedAccounts from "../components/campaign/ConnectedAccounts";
import { PLATFORMS } from "../components/campaign/shared";
import AppHeader from "../components/ds/AppHeader";
import { useTranslation } from "../context/TranslationContext";

/** Figma V6.5: the accounts a creator posts from, for every campaign in the space. */
const MintSpaceAccountsPage = ({ isDark, setToast }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-space-24 font-ds">
      <AppHeader app="creator-rewards" eyebrow="Creator Rewards" title={t("campaignFlow.connectedAccounts")} subtitle="Creator Rewards" />
      <ConnectedAccounts platforms={PLATFORMS} intro={t("campaignFlow.accountsIntro")} setToast={setToast} isDark={isDark} />
    </div>
  );
};

export default MintSpaceAccountsPage;
